import React from 'react';
import type {ActiveFilterChip} from './list-active-filter-chips';

type ActiveFilterSummaryViewProps = {
    chips: readonly ActiveFilterChip[];
    onRemove: (chip: ActiveFilterChip, index: number) => void;
    onClearAll: () => void;
    removeButtonRef: (id: string, element: HTMLButtonElement | null) => void;
};

export const ActiveFilterSummaryView: React.FC<ActiveFilterSummaryViewProps> = ({chips, onRemove, onClearAll, removeButtonRef}) => {
    if (chips.length === 0) {
        return null;
    }

    return (
        <div
            className="store-active-filters"
            role="region"
            aria-label="Active filters"
        >
            <ul>
                {chips.map((chip, index) => (
                    <li key={chip.id}>
                        <button
                            type="button"
                            className="store-active-filters-chip"
                            aria-label={chip.removeName}
                            ref={element => {
                                removeButtonRef(chip.id, element);
                            }}
                            onClick={() => onRemove(chip, index)}
                        >
                            <span className="store-active-filters-chip-label">{chip.label}</span>
                            <span
                                className="store-active-filters-dismiss"
                                aria-hidden="true"
                            >
                                ×
                            </span>
                        </button>
                    </li>
                ))}
            </ul>
            <button
                type="button"
                className="store-active-filters-clear"
                onClick={onClearAll}
            >
                Clear all
            </button>
        </div>
    );
};
